import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './styles.css';
import MainLayout from './layouts/MainLayout';
import DashboardLayout from './layouts/DashboardLayout';
import Home from './pages/Home';
import OurMission from './components/OurMission';
import Login from './pages/Login';
import Register from './pages/Register';
import StudentDashboard from './pages/StudentDashboard';
import Progress from './pages/Progress';
import Courses from './pages/Courses';
import Calendar from './pages/Calendar';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import About from './pages/About';

function App() {
    return (
        <Routes>
            <Route element={<MainLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/our-mission" element={<OurMission />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
            </Route>

            <Route path="/dashboard" element={<DashboardLayout />}>
                <Route index element={<StudentDashboard />} />
                <Route path="progress" element={<Progress />} />
                <Route path="courses" element={<Courses />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="messages" element={<Messages />} />
                <Route path="settings" element={<Settings />} />
            </Route>
        </Routes>
    );
}

export default App;